import warrantyMdl from "./warranty.mdl";
import replacementHandoffMdl from "./replacementHandoff.mdl";

export default [...warrantyMdl, ...replacementHandoffMdl];
